import React from 'react';
// Data
import { smallGalleryImagesArray } from '../../utils/data/GalleryData';
// Components

function SmallGalleryComponent() {
  return (
    <section className='grid gap-8 lg:items-center'>
      <div className='grid w-full px-6 sm:px-8 md:px-12 lg:px-24 lg:container lg:mx-auto'>
        {/* Header */}
        <section className='grid'>
          <article className='grid gap-2 text-center'>
            <h4 className='font-StencilW01 text-3xl text-colour5 dark:text-colour5'>
              A glimpse into my private sessions
            </h4>
            <div className='text-sm lg:px-20'>
              <p>
                Step into the world of my exclusive BDSM experiences, where
                select moments from my sessions are showcased. This gallery
                embodies confidence, dominance, and my unique style, offering an
                enticing glimpse for those who appreciate my craft.
              </p>
            </div>
          </article>
        </section>
      </div>
      {/* Gallery */}
      <section className='grid grid-cols-2 grid-rows-2 md:max-h-[80vh] lg:max-h-[60vh] md:grid-cols-4 md:grid-rows-1 md:px-6'>
        {smallGalleryImagesArray.map((image) => (
          <div
            key={image.id}
            className='relative w-full h-full overflow-hidden group'
          >
            <img
              src={image.src}
              alt={image.alt}
              aria-label={image.ariaLabel}
              className='w-full h-44 object-cover transition-transform duration-300 group-hover:scale-110'
              loading='lazy'
            />

            {/* Pink overlay */}
            <div className='absolute inset-0 bg-colour6 dark:bg-colour6 opacity-0 group-hover:opacity-70 transition-opacity duration-300' />

            {/* Description */}
            <div className='absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 text-white text-center transition-opacity duration-300 dark:text-colour2'>
              <p className='text-lg font-semibold'>{image.description}</p>
            </div>
          </div>
        ))}
      </section>
    </section>
  );
}

export default SmallGalleryComponent;
